import { LinkProps } from '@components/all-purpose-link'
import Link from 'next/link'
import React, { forwardRef } from 'react'

export const PrefixedLink = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ href, children, ...props }: LinkProps, ref: React.ForwardedRef<HTMLAnchorElement>): React.ReactElement => {
    return (
      <Link ref={ref} href={getPrefixedLinkPath(href as string)} {...props}>
        {children}
      </Link>
    )
  }
)
PrefixedLink.displayName = 'PrefixedLink'

export function getPrefixedLinkPath(href: string): string {
  if (href.startsWith('/')) {
    return `/${href.slice(1)}`
  } else {
    return `/${href}`
  }
}
